/**
 * fuarAsamalari.js — bir fuarın aşamaları (belge kabul, dijital belge kabul, kurulum, fuar, söküm) ve her birinin tarih-saat aralığı
 * (backlog #561, salt okunur Fuar Bilgisi sayfası).
 *
 * Girdi, `GET /fuar/list` / `GET /fuar/selectable` öğesidir (FuarListDTO): `fuarDocumentsStartDate` "yyyy-MM-dd", `fuarDocumentsStartTime`
 * "HH:mm:ss" gibi alanlar. Saat isteğe bağlıdır; fuar formundaki (fairsform.js) kuralla aynı: saat yoksa başlangıç gün başı, bitiş gün
 * sonu sayılır. Tarih HER ZAMAN gg/aa/yyyy gösterilir (#560), tarayıcı diline bağlı değil.
 */

// Zaman çizgisindeki sıra; alan adları FuarListDTO'dakilerdir. `ilk` ve `son` = [tarih alanı, saat alanı].
export const FUAR_ASAMALARI = [
  { anahtar: "belgeKabul", simge: "bx-file", ilk: ["fuarDocumentsStartDate", "fuarDocumentsStartTime"], son: ["fuarDocumentsEndDate", "fuarDocumentsEndTime"] },
  { anahtar: "dijitalBelgeKabul", simge: "bx-mail-send", ilk: ["fuarDigitalDocumentsStartDate", "fuarDigitalDocumentsStartTime"], son: ["fuarDigitalDocumentsEndDate", "fuarDigitalDocumentsEndTime"] },
  { anahtar: "kurulum", simge: "bx-wrench", ilk: ["fuarSetupStartDate", "fuarSetupStartTime"], son: ["fuarSetupEndDate", "fuarSetupEndTime"] },
  { anahtar: "fuar", simge: "bx-calendar-star", ilk: ["fuarStartDate", "fuarStartTime"], son: ["fuarEndDate", "fuarEndTime"] },
  { anahtar: "sokum", simge: "bx-package", ilk: ["fuarBreakStartDate", "fuarBreakStartTime"], son: ["fuarBreakEndDate", "fuarBreakEndTime"] },
];

const tarihOku = (v) => (typeof v === "string" && /^\d{4}-\d{2}-\d{2}/.test(v) ? v.slice(0, 10) : null);
const saatOku = (v) => (typeof v === "string" && /^\d{2}:\d{2}/.test(v) ? v.slice(0, 5) : null);

/** "2026-11-05", "09:00" → "05/11/2026 09:00"; saat yoksa yalnızca tarih; tarih yoksa "—". */
export function tarihSaatMetni({ tarih, saat } = {}) {
  if (!tarih) return "—";
  const [y, a, g] = tarih.split("-");
  return `${g}/${a}/${y}${saat ? ` ${saat}` : ""}`;
}

/** Fuarın dolu aşamaları, zaman çizgisi sırasıyla: [{ anahtar, simge, ilk: { tarih, saat }, son: { tarih, saat } }]. Hiç tarihi olmayan aşama (ör. dijital belge kabul) atlanır. */
export function fuarAsamalari(fuar) {
  if (!fuar) return [];
  return FUAR_ASAMALARI
    .map(({ anahtar, simge, ilk, son }) => ({
      anahtar,
      simge,
      ilk: { tarih: tarihOku(fuar[ilk[0]]), saat: saatOku(fuar[ilk[1]]) },
      son: { tarih: tarihOku(fuar[son[0]]), saat: saatOku(fuar[son[1]]) },
    }))
    .filter((a) => a.ilk.tarih || a.son.tarih);
}

const pad = (n) => String(n).padStart(2, "0");
const yerelAnahtar = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

/**
 * "gelecek" | "suruyor" | "gecmis" | null (başlangıcı ya da bitişi bilinmiyorsa durum söylenmez). Karşılaştırma tarayıcının yerel saatiyle
 * "yyyy-MM-ddTHH:mm:ss" metinleri üzerinden; saatsiz başlangıç gün başı, saatsiz bitiş gün sonu.
 */
export function asamaDurumu(asama, simdi = new Date()) {
  if (!asama?.ilk?.tarih || !asama?.son?.tarih) return null;
  const bas = `${asama.ilk.tarih}T${asama.ilk.saat ? `${asama.ilk.saat}:00` : "00:00:00"}`;
  const bit = `${asama.son.tarih}T${asama.son.saat ? `${asama.son.saat}:00` : "23:59:59"}`;
  const t = yerelAnahtar(simdi);
  if (t < bas) return "gelecek";
  if (t > bit) return "gecmis";
  return "suruyor";
}
